import React from "react";

import {
  formatMeddGroupLabelDisplay,
  formatMeddKeyDisplay,
  formatMeddRoleLabelDisplay,
  getInitials,
  meddpiccCanonicalToMatrixKey,
  readCustomerMeddpiccRole,
  resolveCustomerMeddRoleLabel,
  resolveCustomerMemberTitle,
} from "./relationshipUtils";
import { getCustomerContactAvatarBg } from "../../../Utils/Helper/profileAvatarUi";

/** Column header for customer contacts in coverage + Account Details matrices. */
export function CustomerTeamColumnHeader({
  member,
  showMeddpiccRole = true,
  formatMeddKey = undefined,
  formatMeddLabel = undefined,
}) {
  const name = member.member_name || member.name || "Contact";
  const memberTitle = resolveCustomerMemberTitle(member);
  const meddKey = meddpiccCanonicalToMatrixKey(
    readCustomerMeddpiccRole(member)
  );
  const meddLabel = resolveCustomerMeddRoleLabel(member);
  const displayMeddKey =
    typeof formatMeddKey === "function"
      ? formatMeddKey(meddKey)
      : formatMeddKeyDisplay(meddKey);
  const displayMeddLabel =
    typeof formatMeddLabel === "function"
      ? formatMeddLabel(meddLabel)
      : formatMeddRoleLabelDisplay(meddLabel);
  const avatarBg = getCustomerContactAvatarBg();
  const mCls = `medd medd-${String(meddKey).toLowerCase()}`;

  return (
    <>
      <div className="c-avatar" style={{ background: avatarBg }}>
        {getInitials(name)}
      </div>
      <div className="c-name">{name}</div>
      {memberTitle ? <div className="c-title">{memberTitle}</div> : null}
      {showMeddpiccRole && meddKey ? (
        <span
          className={mCls}
          style={{ marginTop: 2, display: "inline-flex", fontSize: 9 }}
          title={displayMeddLabel}
        >
          {displayMeddKey}
        </span>
      ) : null}
    </>
  );
}

/** MEDDPICC group header row (Buying Committee, Influence Network, etc.). */
export function CustomerTeamMeddGroupHeaderRow({ groupSpans }) {
  if (!groupSpans?.length) return null;

  return (
    <tr>
      <th className="rh" aria-label="MEDDPICC groups" />
      {groupSpans.map(grp => {
        const displayLabel = formatMeddGroupLabelDisplay(grp.label);
        return (
          <th
            key={grp.group}
            colSpan={grp.span}
            className={`medd-grp-hdr medd-grp-${grp.group}`}
            title={displayLabel}
          >
            {displayLabel}
          </th>
        );
      })}
    </tr>
  );
}

export function customerTeamMeddSubtitle(
  member,
  { considerMeddpiccRole = true } = {}
) {
  if (considerMeddpiccRole) {
    return (
      formatMeddRoleLabelDisplay(resolveCustomerMeddRoleLabel(member)) ||
      member.member_title ||
      ""
    );
  }
  return member.member_title || member.role || "";
}
